module.exports = __webpack_public_path__ + "static/media/ic_ascensor_pin.56c841c2.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/ic_ascensor_pin.webp
// module id = 204
// module chunks = 1